/***********************************************************************************************************************
 * Purpose: Opens the design in the context on a pop-up modal.
 *
 * Note: It depends on AccountDesignsOrdersContext. 🐺
 * ***************************************************
 *
 *  @format */

import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import {AdaptiveImage, ImageViewer, If} from 'frontier-utilities';
import {IfElse} from 'frontier-utilities';
import React, {useContext} from 'react';

// style
import './single_design_preview.scss';

export default function SingleDesignPreview(props) {
    const {children} = props;

    const ctx = useContext(AccountDesignsOrdersContext);

    const handleGetImageWidth = () => {
        if (ctx.design.pressready_thumb_width > ctx.design.pressready_thumb_height) {
            return {width: '90vw', height: 'auto'};
        } else {
            return {width: 'auto', height: '90vh'};
        }
    };

    return (
        <ImageViewer
            src={ctx.design.pressready_thumb_signed_url}
            filename={ctx.design.customer_filename}
            shouldUseAdaptiveImage={false}
            width={handleGetImageWidth().width}
            height={handleGetImageWidth().height}>
            <div className="single-design-preview-02pp">
                <If condition={props.showThumbnails}>
                    <div className="single-design-preview-02pp__thumbnail">
                        <AdaptiveImage
                            src={ctx.design.pressready_thumb_signed_url}
                            title={ctx.design.customer_filename}
                            style={{
                                margin: '10px 0'
                            }}
                            width="235px"
                        />
                    </div>
                </If>
                <IfElse condition={!!children}>
                    <>{children}</>
                    <button
                        className="single-design-preview-02pp__button color-accent-primary
                        d-flex align-items-center justify-content-start
                        p-0 m-0 ">
                        <i className="fa fa-eye" />
                        <span
                            title={ctx.designs_order.filename_without_id}
                            className="text-nowrap"
                            style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                            {ctx.designs_order.filename_without_id}
                        </span>
                    </button>
                </IfElse>
            </div>
        </ImageViewer>
    );
}
